// extracted by mini-css-extract-plugin
export default {"logo":"MenuLogo__logo--3cb2L","icon":"MenuLogo__icon--2r0-J"};